import moment from "moment";

export function initialiseNightlyUpdate() {
    const timeToReload = moment().add(1, "days").startOf("day");
    const intervalToCheckForReload = 10 * 60 * 1000;

    window.setInterval(function() {
        const now = moment();

        if (now.isSameOrAfter(timeToReload)) {
            window.location.reload();
        }
    }, intervalToCheckForReload);
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/appUpdate.js
 **/